import { createParticles } from './tj10-particles.js';

const stage = document.querySelector('.shield-stage');
const canvas = document.querySelector('#shield-canvas');
const morphButton = document.querySelector('[data-shield-morph]');
const preference = matchMedia('(prefers-reduced-motion: reduce)');
let engine, scattered = false, paused = preference.matches, visible = false;

function syncPause() {
  engine?.pause(paused || !visible);
}
function fail(reason) {
  console.warn('Shield animation unavailable:', reason || 'WebGL context lost');
  stage.classList.remove('is-ready');
  stage.querySelector('.shield-error').hidden = false;
  stage.querySelector('.shield-interaction').hidden = true;
  engine?.destroy();
}
const observer = new IntersectionObserver(entries => {
  visible = entries[0].isIntersecting;
  syncPause();
}, { threshold: 0.05 });
observer.observe(stage);

fetch(stage.dataset.pointsUrl || new URL('./tj10-emblem-points.json', import.meta.url)).then(response => {
  if (!response.ok) throw new Error('Unable to load emblem');
  return response.json();
}).then(points => {
  if (!Array.isArray(points) || points.length < 100) throw new Error('Invalid emblem');
  engine = createParticles(canvas, points, paused, () => {}, fail);
  stage.classList.add('is-ready');
  syncPause();
}).catch(fail);

morphButton.addEventListener('click', () => {
  scattered = !scattered;
  engine?.morph(scattered);
  morphButton.textContent = scattered ? morphButton.dataset.labelGather : morphButton.dataset.labelScatter;
  morphButton.setAttribute('aria-pressed', String(scattered));
});
preference.addEventListener('change', event => { paused = event.matches; syncPause(); });
window.addEventListener('pagehide', () => { observer.disconnect(); engine?.destroy(); });
